import React from 'react';
import { PreviewPanelWrapper } from './PreviewPanel1';
import { Col } from 'reactstrap';

const PreviewPanel9 = ({ textColor, completedEvents }) => (
    <PreviewPanelWrapper textColor={textColor} icon="fa-calendar-alt">
        <Col>
            <h4 className="pt-3">Completed Events</h4>
        </Col>
        <Col className="text-right">
            <h1 className="display-4 text-bold">{completedEvents}</h1>
        </Col>
    </PreviewPanelWrapper>
);

export default PreviewPanel9;
